import React, { useState } from "react";
import {
  Container,
  TextField,
  Button,
  Typography,
  Alert,
  CircularProgress,
  Box,
  Paper,
} from "@mui/material";
import { deleteUser2 } from "../../api/Api";

function DeleteAccount() {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    reason: "",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleDelete = async (e) => {
    e.preventDefault();

    if (!formData.email || !formData.password) {
      setError("Email and password are required.");
      return;
    }

    setLoading(true);
    setError("");
    setSuccess("");

    try {
      const response = await deleteUser2(formData);
      
      if (response.data.success) {
        setSuccess(response.data.message);
        setFormData({ email: "", password: "", reason: "" });
        // Optionally redirect or handle successful deletion
      }
    } catch (err) {
      setError(
        err.response?.data?.message || 
        "Failed to delete account. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="sm" sx={{ my: 4 }}>
      <Paper elevation={3} sx={{ p: 3 }}>
        <Typography variant="h5" align="center" gutterBottom>
          Delete Your Account
        </Typography>

        <Alert severity="warning" sx={{ mb: 3 }}>
          This action is permanent and cannot be undone.
        </Alert>

        <Box
          component="form"
          onSubmit={handleDelete}
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 3,
          }}
        >
          <TextField
            label="Email"
            name="email"
            type="email"
            variant="outlined"
            fullWidth
            value={formData.email}
            onChange={handleInputChange}
            required
          />

          <TextField
            label="Password"
            name="password"
            type="password"
            variant="outlined"
            fullWidth
            value={formData.password}
            onChange={handleInputChange}
            required
          />

          <TextField
            label="Reason (Optional)"
            name="reason"
            variant="outlined"
            multiline
            rows={3}
            fullWidth
            value={formData.reason}
            onChange={handleInputChange}
          />

          {error && <Alert severity="error">{error}</Alert>}
          {success && <Alert severity="success">{success}</Alert>}

          <Button
            type="submit"
            variant="contained"
            color="error"
            disabled={loading}
          >
            {loading ? <CircularProgress size={24} /> : "Delete Account"}
          </Button>
        </Box>
      </Paper>
    </Container>
  );
}

export default DeleteAccount;